import { defineMessages, IntlShape } from 'react-intl'
import * as yup from 'yup'

import { IPaymentSummariesFormValues } from 'features/PaymentsSummary/types'

const nameMessages = defineMessages({
  required: {
    id: 'paymentSummary.new.form.name.required',
    defaultMessage: 'Name is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IPaymentSummariesFormValues> => {
  return yup.object().shape({
    name: yup.string().required(intl.formatMessage(nameMessages.required)),
    files: yup.array().of(
      yup.object().shape({
        id: yup.string().optional(),
        category: yup.mixed().required(),
        name: yup.string().optional(),
        file: yup.mixed().optional(),
        path: yup.string().optional(),
        errorPath: yup.string().optional()
      })
    )
  })
}
